<template>
  <basic-container>
    <div class="custom-title">
      <div class="custom-block tip">
        <p class="custom-block-title">{{ title }}</p>
        <span style="padding-left: 20px; color: #dd6161; font-weight: bold">{{ lineName }}</span>
      </div>
      <div class="return-list">
        <el-button
          icon="el-icon-back"
          size="mini"
          @click="returnIndex('/product/transport/runningplan/runningplan-list')"
        >
          返回列表
        </el-button>
      </div>
    </div>
    <div class="form-contain">
      <el-form ref="form" :model="form" size="small" label-width="100px" :rules="rules">
        <el-form-item label="班次类型：">
          <avue-radio v-model="form.type" :dic="[{ label: '固定班次', value: 1 }]" />
        </el-form-item>

        <el-form-item label="生效日期：">
          <div style="display: flex">
            <avue-date
              v-model="times"
              type="daterange"
              format="yyyy-MM-dd"
              valueFormat="yyyy-MM-dd"
              :picker-options="pickerOptions"
              @change="handleChangeTimes"
            />
            <div class="tipsBox">
              <img style="width: 20px; height: 20px" src="./static/tips.png" />
              <span>点击某一天两下代表只选择那一天排班！</span>
            </div>
          </div>
          <div class="tip" style="">
            <span class="fs">注意：排班时间跨度最长为30天</span>
          </div>
        </el-form-item>

        <el-form-item label="供应商：">
          <avue-select
            v-model="form.merchantId"
            :dic="merchantSelectData"
            :props="{ label: 'merchantName', value: 'id' }"
            placeholder="试试搜索:请选择供应商"
            filterable
            style="width: 15vw"
            @change="handleMerchSelect"
          />
          <div class="tip">
            <span class="fs">*注意：请选择服务的供应商再添加班次</span>
          </div>
        </el-form-item>

        <el-form-item label="设置排班：">
          <div style="display: flex; justify-content: flex-start; flex-flow: row">
            <el-button
              type="danger"
              size="small"
              :loading="isMerchSelect"
              :disabled="!form.merchantId"
              @click="handleAddRow"
            >
              单个班次添加
            </el-button>
            <el-button
              type="danger"
              size="small"
              :loading="isMerchSelect"
              :disabled="!form.merchantId"
              @click="handleBatchPlantime"
            >
              按时间批量添加班次
            </el-button>
            <el-button
              type="danger"
              size="small"
              :loading="isMerchSelect"
              :disabled="!form.merchantId"
              @click="handleBatchDriverPlan"
            >
              按司机批量添加班次
            </el-button>
          </div>
          <div style="margin-top: 10px">
            <el-table :data="runningPlanTimeList" border column-key="uuid" highlight-current-row>
              <el-table-column label="序号" type="index" width="50" align="center" />
              <el-table-column label="时间" width="210" align="center" prop="departureTime">
                <template slot-scope="scope">
                  <span v-if="!scope.row.timeRangeShow">
                    <span v-if="!scope.row.isnew">{{ scope.row.departureTime }}</span>
                    <span v-else>
                      <el-time-picker
                        v-model="scope.row.departureTime"
                        :picker-options="{ selectableRange: '00:00:01 - 23:59:59' }"
                        value-format="HH:mm"
                        format="HH:mm"
                      />
                    </span>
                  </span>
                  <el-time-picker
                    v-else
                    is-range
                    v-model="scope.row.timeRange"
                    range-separator="至"
                    start-placeholder="开始时间"
                    end-placeholder="结束时间"
                    placeholder="选择时间范围"
                    format="HH:mm"
                    value-format="timestamp"
                    size="mini"
                    style="width: 180px"
                    @change="timeRangeChange($event, scope.row)"
                  />
                  <el-button
                    v-has-permi="['transport_runningplan_range']"
                    style="margin-left: 10px"
                    type="text"
                    @click="scope.row.timeRangeShow = !scope.row.timeRangeShow"
                  >
                    {{ scope.row.timeRangeShow ? '返回' : '区间发班' }}
                  </el-button>
                </template>
              </el-table-column>
              <el-table-column label="价格方案" width="400" align="center">
                <template slot-scope="scope">
                  <el-select
                    @change="seleRowPrice(scope.$index, scope.row)"
                    v-model="scope.row.priceMethodId"
                    placeholder="请选择价格方案"
                  >
                    <el-option
                      v-for="item in priceMethodDic"
                      :key="item.carTypeId"
                      :label="item.priceMethodName"
                      :value="item.priceMethodId"
                    />
                  </el-select>
                  <el-button
                    style="margin-left: 10px"
                    type="text"
                    v-if="scope.row.priceMethodId !== ''"
                    @click.stop="handlePriceView(scope.row, scope.$index)"
                  >
                    改价
                  </el-button>
                </template>
              </el-table-column>
              <el-table-column label="司机车辆信息" width="220" align="center" prop="driverId">
                <template slot-scope="scope">
                  <span>{{ scope.row.driverInfo }}</span>
                  <span class="p10">
                    <el-button
                      type="text"
                      size="small"
                      @click="handleSetDriver(scope.$index, scope.row)"
                    >
                      设置
                    </el-button>
                  </span>
                </template>
              </el-table-column>
              <el-table-column
                label="站点配置"
                width="480"
                align="center"
                prop="stationConfigVos"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <span>
                    <el-tag size="small" type="primary">{{ scope.row.stationNameGroup }}</el-tag>
                  </span>
                </template>
              </el-table-column>
              <el-table-column label="标签" width="300" align="center" prop="labelCheck">
                <template slot-scope="scope">
                  <el-popover
                    :popper-class="'popbox-' + scope.row.uuid"
                    :key="scope.row.uuid"
                    placement="bottom"
                    width="160"
                    trigger="manual"
                    v-model="scope.row.labelVisible"
                  >
                    <div
                      style="padding: 0px 0px 20px 20px; max-height: 200px; overflow-y: scroll"
                      v-loading="labelLoading"
                    >
                      <el-checkbox-group
                        :max="2"
                        v-model="scope.row.labelCheck"
                        @change="labelCheckChange"
                      >
                        <div
                          v-for="item in labelCheckList"
                          :key="item.label"
                          style="display: flex; justify-content: space-between; align-items: center"
                        >
                          <el-checkbox :label="item.type">{{ item.name }}</el-checkbox>
                          <el-button
                            size="mini"
                            type="text"
                            icon="el-icon-edit"
                            v-has-permi="['edit_label']"
                            @click="handleAdd(item, 'edit')"
                          >
                            编辑
                          </el-button>
                        </div>
                      </el-checkbox-group>
                    </div>
                    <div class="flex flex-justify-between">
                      <div>
                        <el-button
                          size="mini"
                          type="text"
                          v-has-permi="['add_label']"
                          @click="handleAdd(scope.row, 'add')"
                        >
                          添加
                        </el-button>
                      </div>
                      <div>
                        <el-button size="mini" type="text" @click="addLabels(scope.row)">
                          取消
                        </el-button>
                        <el-button type="primary" size="mini" @click="submitLabel(scope.row)">
                          确定
                        </el-button>
                      </div>
                    </div>
                    <el-button
                      slot="reference"
                      type="text"
                      class="add-labels"
                      @click="addLabels(scope.row, scope)"
                    >
                      添加
                    </el-button>
                  </el-popover>
                  <span>
                    <el-tag
                      v-for="item in scope.row.labelList"
                      :key="item.uuid"
                      closable
                      type="warning"
                      size="small"
                      style="margin-right: 5px"
                      @close="handleCloseLabel(item.id, scope.row)"
                    >
                      {{ labelCheckList.filter((it) => +it.id === +item.id)[0].name }}
                    </el-tag>
                  </span>
                </template>
              </el-table-column>

              <el-table-column label="置顶标签" width="300" align="center" prop="topLableIds">
                <template slot-scope="scope">
                  <el-checkbox-group
                    v-model="scope.row.topLableIds"
                    @change="(val) => handleLabelChange(val, scope.row)"
                  >
                    <el-checkbox v-for="item in scope.row.labelList" :label="item" :key="item">
                      {{ labelCheckList.filter((it) => +it.id === +item.id)[0].name }}
                    </el-checkbox>
                  </el-checkbox-group>
                </template>
              </el-table-column>

              <el-table-column label="操作" align="center" fixed="right">
                <template slot-scope="scope">
                  <el-button type="text" size="small" @click="removeRow(scope.row)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-form-item>
      </el-form>
      <div style="display: flex; justify-content: flex-end; flex-flow: row; padding-bottom: 30px">
        <el-button type="info" size="small" @click="cancel">取消</el-button>
        <el-button type="primary" size="small" @click="submit">保存</el-button>
      </div>
    </div>
    <!--批量添加班次-->
    <batch-running-plan
      v-if="plantimeShowDialog"
      ref="planAdd"
      :labelList="labelCheckList"
      @batchPlanTime="handlePlanTimeData"
      @addLabelClose="getLabelList"
    />
    <batch-driver-plan
      v-if="driverPlanShowDialog"
      ref="driverPlanAdd"
      :labelList="labelCheckList"
      @batchPlanTime="handlePlanTimeData"
      @addLabelClose="getLabelList"
    />

    <set-station v-if="setStationShowDialog" ref="setStation" @LineFormData="handlelinedata" />
    <set-driver v-if="setDriverShowDialog" ref="setDriver" @DriverFormData="handledriverdata" />
    <price-view ref="priceview" v-if="showViewPriceDialog" @revisePriceInfo="revisePriceInfo" />
    <!--设置价格方案-->
    <el-dialog title="设置价格方案" :visible.sync="setVisible" :append-to-body="true" width="50%">
      <el-form :model="info" size="small" :inline="true">
        <el-form-item>
          <el-row style="margin: auto 0">
            <el-col :span="8" style="padding-left: 10px">
              <avue-select
                placeholder="请选择价格方案"
                :dic="uniquePriceMethod(priceMthodItems)"
                :disabled="pricemethodDisabled"
                v-model="info.priceMethodId"
                :props="{ label: 'priceMethodName', value: 'priceMethodId' }"
                style="width: 20vw"
                @change="handleSelectPrice"
              />
            </el-col>
          </el-row>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" type="danger" @click="setCancel">取 消</el-button>
        <el-button type="primary" size="small" @click="setSubmit">确 定</el-button>
      </div>
    </el-dialog>
    <AddLabel ref="addLabel" @close="getLabelList" />
  </basic-container>
</template>

<script>
  import {
    priceSchemeList,
    save,
    getStationRule,
    getPageMerchant,
    labelList
  } from '@/api/transport/bustime'
  import { getPriceDetail } from '@/api/transport/pricescheme'
  import { uuidv5 } from '@/util/util'

  import batchRunningPlan from './components/batch-runningplan'
  import batchDriverPlan from './components/batch-driver-plan'
  import setStation from './components/set-station'
  import SetDriver from './components/set-driver'
  import priceView from './components/price-view'
  import dayjs from 'dayjs'
  import useHandleLabel from './components/hooks/useLabel.js'
  import AddLabel from './components/add-label.vue'

  export default {
    name: 'RunningPlan',
    filters: {},
    components: {
      SetDriver,
      batchRunningPlan,
      setStation,
      priceView,
      batchDriverPlan,
      AddLabel
    },
    data() {
      return {
        labelCheckFlag: false,
        labelCheck: [],
        priceInfo: [],
        addPriceId: '',
        title: '新增班次',
        lineId: '',
        lineName: '',
        setVisible: false,
        pricemethodDisabled: true,
        carLevelDisable: true,
        plantimeShowDialog: false,
        driverPlanShowDialog: false,
        setStationShowDialog: false,
        setDriverShowDialog: false,
        showViewPriceDialog: false,
        isMerchSelect: false, // 是否选中价格方案
        seats: null,
        priceMethodDic: [], // 价格方案
        merchantSelectData: [],
        merchantId: '',
        times: [], // 选择时间数组
        form: {
          // 待传表单
          type: 1,
          lineId: 0,
          startDate: '',
          endDate: '',
          merchantId: '',
          scheduleInfos: []
        },
        lines: [], // 站点
        driversForm: {}, // 司机信息
        rules: {},
        priceId: '',
        priceName: '',
        tableIndex: 0,
        info: {
          // 设置价格方案
          carSeat: '',
          carSeatName: '',
          carType: '',
          carTypeName: '',
          priceMethodId: '',
          priceMethodName: ''
        },
        stationRuleList: [],
        selectiondAll: {
          // 选中所有数据
          stationNameGroup: '',
          stationName: '', // 站点名称
          data: [] // 站点数据
        },
        labelCheckList: [],
        labelLoading: false,
        pickerOptions: {
          disabledDate(time) {
            return (
              time.getTime() < Date.now() - 8.64e7 * 30 ||
              time.getTime() > Date.now() - 8.64e7 * -30
            )
          }
        }
      }
    },
    computed: {
      runningPlanTimeList: {
        get() {
          return this.$store.state.customtrans.runningPlanTimeForm
        },
        set(val) {
          this.$store.commit('UPDATE_RUNNING_PLAN_FORM', val)
        }
      },
      carTypeItems: {
        get() {
          return this.$store.state.customtrans.carTypeList
        },
        set(val) {
          this.$store.commit('UPDATE_CAR_TYPE_LIST', val)
        }
      },
      priceMthodItems: {
        get() {
          return this.$store.state.customtrans.priceMethodSelect
        },
        set(val) {
          this.$store.commit('UPDATE_PRICE_METHOD_LIST', val)
        }
      }
    },
    created() {
      this.init()
    },
    setup() {
      const { getLabelName } = useHandleLabel()
      return {
        getLabelName
      }
    },
    methods: {
      handleLabelChange(newVal, row) {
        // 如果选择了新的选项（从选中1个变成选中2个）
        if (newVal.length > 1) {
          // 只保留最后一个选中的
          const lastSelected = newVal[newVal.length - 1]
          row.topLableIds = [lastSelected]
        }
      },
      labelCheckChange(v) {
        this.labelCheck = v
      },
      timeRangeChange(val, obj) {
        obj.adjustTime = (val[0] - val[1]) / 60000
        // obj.departureTime = dayjs(val[1]).format('HH:mm')
      },
      submitLabel(item, index) {
        console.log('item', item, index)
        const params = []
        // eslint-disable-next-line array-callback-return

        item.labelCheck.forEach((item) => {
          params.push({
            id: item,
            uuid: uuidv5()
          })
        })

        this.$set(item, 'labelList', params)
        item.labelVisible = !item.labelVisible
      },
      addLabels(item) {
        item.labelVisible = !item.labelVisible
        this.$nextTick(() => {
          const pops = document.querySelectorAll(`.popbox-${item.uuid}`)
          if (pops.length > 1) {
            pops[1].style.display = 'none'
          }
        })
        this.getLabelList()
      },
      handleCloseLabel(item, obj) {
        const index = obj.labelList.findIndex((val) => val.id === item)
        const index1 = obj.labelCheck.findIndex((val) => val === item)
        obj.labelList.splice(index, 1)
        obj.labelCheck.splice(index1, 1)
      },
      async init() {
        this.lineId = this.$route.params && this.$route.params.lineId
        this.lineName = this.$route.params && this.$route.params.lineName
        this.getMerchantSelect(this.lineId)
      },
      // 列表重选价格方案
      seleRowPrice(index, val) {
        val.driverInfo = ''
        getPriceDetail(val.priceMethodId).then((resp) => {
          this.runningPlanTimeList[index].flightPriceMethodTypes = resp.data
        })
      },
      // 修改价格方案
      revisePriceInfo(val) {
        this.runningPlanTimeList[val.index].flightPriceMethodTypes = val.flightPriceMethodTypes
        this.$message.success('保存成功')
      },
      // 选择生效日期时间
      handleChangeTimes(val) {
        this.times = val
      },
      // 按时间批量添加班次
      handleBatchPlantime() {
        this.getLabelList()
        this.plantimeShowDialog = true
        this.$nextTick(() => {
          const row = {
            lineId: this.lineId,
            merchantId: this.merchantId
          }
          this.$refs.planAdd.init(row)
        })
      },
      // 按司机批量添加班次
      handleBatchDriverPlan() {
        this.driverPlanShowDialog = true
        this.$nextTick(() => {
          const row = {
            lineId: this.lineId,
            merchantId: this.merchantId
          }
          this.$refs.driverPlanAdd.init(row)
        })
      },
      // 打开站点配置弹窗
      handleSetStation(index, column) {
        this.setStationShowDialog = true
        this.$nextTick(() => {
          const row = {
            lineId: this.lineId,
            merchantId: this.merchantId,
            index,
            column,
            type: 'SET',
            isChecked: column.stationConfigVos.length > 0
          }
          this.$refs.setStation.init(row)
        })
      },
      // 打开司机设置弹窗
      handleSetDriver(index, row) {
        this.setDriverShowDialog = true
        this.$nextTick(() => {
          this.$refs.setDriver.init(index, row, this.merchantId)
        })
      },
      handlePlanTimeData(fromData) {
        const list = this.runningPlanTimeList.concat(fromData)
        list.forEach((item) => {
          this.$set(item, 'timeRangeShow', false)
          this.$set(item, 'timeRangeShow', false)
          this.$set(item, 'timeRange', '')
        })
        this.$store.commit('ADD_RUNNING_PLAN_FORM', list)
      },

      // 改变供应商事件
      async handleMerchSelect(val) {
        if (!val) {
          return
        }
        this.isMerchSelect = true
        this.merchantId = val

        // 清空班次列表
        this.$store.commit('REMOVE_RUNNING_PLAN_FORM')
        this.priceMethodDic = []
        this.addPriceId = ''
        this.priceInfo = []
        this.stationRuleList = []
        this.selectiondAll = {
          stationNameGroup: '',
          stationName: '',
          data: []
        }

        // 获取价格方案列表
        const res = await priceSchemeList({ lineId: this.lineId, merchantId: this.merchantId })
        const { code, data } = res || {}
        if (code !== 0 || !Array.isArray(data)) {
          this.isMerchSelect = false
          return
        }
        this.$store.commit('UPDATE_PRICE_METHOD_DATA', data)
        this.priceMethodDic = data

        // 获取价格明细
        this.addPriceId = data[0] && data[0].priceMethodId ? data[0].priceMethodId : ''
        const res2 = await getPriceDetail(this.addPriceId)
        const { code: num, data: priceList } = res2 || {}
        if (num !== 0 || !Array.isArray(priceList)) {
          this.isMerchSelect = false
          return
        }
        this.priceInfo = priceList

        // 获取站点规则
        const res3 = await getStationRule({
          current: 1,
          size: 9999,
          lineId: this.lineId,
          merchantId: this.merchantId
        })
        const { code: num2, data: stationList } = res3 || {}
        if (num2 !== 0 || !Array.isArray(stationList)) {
          this.isMerchSelect = false
          return
        }
        this.packageStationData(stationList)
        this.isMerchSelect = false
      },
      // 组装站点数据
      packageStationData(list) {
        this.stationRuleList = list.map((item, index) => {
          return {
            index,
            stationId: item.stationId,
            stationName: item.stationName,
            rule: item.rule,
            stationRuleId: Number.parseInt(item.stationRuleId),
            startSellTime: item.startSellTime,
            endSellTime: item.endSellTime,
            isOpen: item.isOpen,
            openPickUp: item.openPickUp,
            pickUpRule: item.pickUpRule,
            pickUpTime: item.pickUpTime,
            pickUpType: item.pickUpType,
            sort: item.sort
          }
        })
        const stationArr = this.stationRuleList.filter((p) => p.isOpen === 1)
        const stationNameArr = stationArr.map((item) => {
          return item.stationName
        })
        this.selectiondAll.stationName = stationNameArr.join('-')
        this.selectiondAll.stationNameGroup =
          `${stationArr.length} 个站点：` + this.selectiondAll.stationName
        this.selectiondAll.data = JSON.parse(JSON.stringify(this.stationRuleList))
      },
      // 批量添加班次选择价格方案
      handleSelectPrice(val) {
        if (val) {
          this.priceId = val
          // 获取label
          let obj = {}
          obj = this.priceMthodItems.find((item) => {
            return item.priceMethodId === val
          })
          this.info.priceMethodName = obj.priceMethodName
        }
      },
      // 修改价格方案
      handlePriceView(item, index) {
        item.index = index
        const obj = JSON.stringify(item)
        this.showViewPriceDialog = true
        this.$nextTick(() => {
          this.$refs.priceview.init(obj)
        })
      },

      // 添加班次
      handleAddRow() {
        const objdata = {
          uuid: uuidv5(),
          isnew: true,
          carId: '',
          carSeatName: '',
          carType: '',
          carSeat: '',
          carTypeName: '',
          departureTime: '',
          stationNameGroup: this.selectiondAll.stationNameGroup || '',
          driverId: '',
          driverInfo: '',
          priceMethodId: this.addPriceId || '',
          flightPriceMethodTypes: this.priceInfo,
          priceMethodName: '',
          stationConfigVos: this.selectiondAll.data || [],
          stationRuleId: '',
          priceMethodTypeList: [],
          labelCheck: [],
          timeRangeShow: false,
          timeRange: '',
          labelVisible: false,
          topLableIds: []
        }
        this.runningPlanTimeList.push(objdata)
      },

      // 删除班次
      removeRow(row) {
        this.$store.commit('REMOVE_ROWP_PLAN_TIME', row)
      },

      handlelinedata(lines) {
        this.lines = lines
      },
      handledriverdata(info) {
        this.$store.commit('UPDATE_PLAN_TIME_ROW_DRIVER', info)
      },

      // 新增班次保存
      submit() {
        if (this.runningPlanTimeList.length === 0) {
          this.$message.error('班次时间不能为空')
          return
        }
        this.runningPlanTimeList.forEach((item) => {
          if (item.labelList && item.labelList.length !== 0) {
            item.labels = item.labelList.map((obj) => {
              return obj.id
            })
          }
          if (item.timeRangeShow) {
            item.departureTime = dayjs(item.timeRange[1]).format('HH:mm')
          }
        })
        this.runningPlanTimeList.forEach((item) => {
          if (item.topLableIds && item.topLableIds.length !== 0) {
            item.topLableIds = item.topLableIds.map((obj) => {
              return obj.id
            })
          }
        })

        this.form.startDate = this.times[0]
        this.form.endDate = this.times[1]
        this.form.lineId = this.lineId
        this.form.scheduleInfos = this.runningPlanTimeList
        const loading = this.$loading({})
        save(this.form)
          .then((resp) => {
            if (resp.code === 0) {
              this.$message.success('保存成功')
              this.reset()
              this.returnIndex('/product/transport/runningplan/runningplan-list')
            }
          })
          .finally(() => {
            loading.close()
          })
      },

      // 取消新增班次
      cancel() {
        this.reset()
        this.$store.commit('REMOVE_CAR_TYPE_LIST')
        this.$store.commit('REMOVE_PRICE_METHOD_LIST')
      },

      // 重置信息
      reset() {
        this.times = []
        this.form = {
          type: 1,
          lineId: 0,
          startDate: '',
          endDate: '',
          merchantId: '',
          scheduleInfos: []
        }
        this.stationRuleList = []
        this.selectiondAll.stationName = ''
        this.$store.commit('REMOVE_RUNNING_PLAN_FORM')
      },
      // 返回
      returnIndex(url) {
        this.$store.commit('REMOVE_PRICE_METHOD_DATA')
        this.$router.push({ path: url })
        this.reset()
      },
      // 获取供应商下拉列表
      getMerchantSelect(lineId) {
        getPageMerchant(lineId).then((resp) => {
          if (resp.data.length === 1) {
            this.form.merchantId = resp.data[0].id
          }
          this.merchantSelectData = resp.data
        })
      },
      uniqueCarType(newarr) {
        const res = new Map()
        return newarr.filter((arr) => !res.has(arr.type) && res.set(arr.type, 1))
      },
      uniquePriceMethod(newarr) {
        const res = new Map()
        return newarr.filter((arr) => !res.has(arr.priceMethodId) && res.set(arr.priceMethodId, 1))
      },

      // 设置价格方案保存
      setSubmit() {
        if (this.info.priceMethodId === '') {
          this.$message.warning('请选择价格方案')
          return
        }
        const anoData = {
          carSeatName: this.info.carSeatName,
          carSeat: this.info.carSeat,
          carType: this.info.carType,
          carTypeName: this.info.carTypeName,
          priceMethodId: this.info.priceMethodId,
          priceMethodName: this.info.priceMethodName
        }
        this.$store.commit('UPDATE_RUNNING_PLAN_FROM_INDE', {
          data: anoData,
          index: this.tableIndex
        })
        this.setCancel()
      },

      // 取消设置价格方案
      setCancel() {
        this.setVisible = false
        this.info = {
          carSeat: '',
          carSeatName: '',
          carType: '',
          carTypeName: '',
          priceMethodId: '',
          priceMethodName: ''
        }
      },
      handleAdd(row, type) {
        console.log(1111, row, type)

        this.$refs.addLabel.init(row, type)
      },
      async getLabelList() {
        try {
          this.labelLoading = true
          const { code, data } = await labelList()
          if (code !== 0) return
          this.labelCheckList = data
        } catch (error) {
          console.log(error)
        } finally {
          this.labelLoading = false
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .tipsBox {
    display: flex;
    align-items: center;
    margin: 0 0 0 10px;
    font-size: 13px;
    color: #9f9f9f;
  }
  .tipsBox span {
    margin-left: 5px;
  }
  .custom-title {
    display: -webkit-flex; /* Safari */
    display: flex;
    justify-content: space-between;
    width: 100%;
    .custom-block.tip {
      border-color: #409eff;
      padding: 0.4rem 0 0 0.5rem;
      border-left-width: 0.3rem;
      border-left-style: solid;
      height: 26px;
      margin: 0;
    }
    .custom-block-title {
      font-weight: 600;
      margin: 0;
    }
    .return-list {
      justify-content: flex-end;
    }
  }
  .form-contain {
    margin-top: 20px;
  }
  ::v-deep .el-date-editor--datetimerange.el-input__inner {
    width: 280px;
  }
  .el-date-editor.el-input {
    width: 7vw;
  }
  .p10 {
    padding: 10px;
  }
  .tip {
    display: flex;
    justify-content: space-between;
    // padding: 5px 0 0 60px;

    .fs {
      font-size: 12px;
      color: #f56c6c;
      font-weight: bold;
    }
  }
  .add-labels {
    color: #e6a23c;
    text-decoration: underline;
    margin-right: 10px;
    cursor: pointer;
  }
  ::-webkit-scrollbar {
    width: 10px;
  }
</style>
